import { withLocalState } from 'pyradux';

import MultiFactorContainer from './MultiFactor.container';
import reducer from './MultiFactor.reducer';
import MultiFactorSagas from './MultiFactor.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'multiFactor',
  sagas: [MultiFactorSagas],
};

export default withLocalState(withLocalStateOptions, MultiFactorContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/MyAccount/MultiFactor/index.js